import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/src/components/breadcrumbs/breadcrumbs.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/faq/faq.module.scss");
import(/* webpackMode: "eager" */ "/app/src/components/text-and-image/text-and-image.module.scss");
import(/* webpackMode: "eager" */ "/app/src/components/list-and-image/list-and-image.module.scss");
import(/* webpackMode: "eager" */ "/app/src/components/advantages/advantages.module.scss");
import(/* webpackMode: "eager" */ "/app/src/uikit/collapse/collapse.tsx")